export function setProvider(provider){
    return async function(dispatch){
        const action = { type : 'SET_PROVIDER', payload : provider}
        dispatch(action);
    }
}

